module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "color": "#ffffff",
      "font-size": "20px",
      "cursor": "pointer",
      "padding-top": "5px"
    },
    on: {
      "click": function($event) {
        _vm.dropMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-ellipsis-v"
  })]), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "menu-nav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.dropMenu()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('ul', [(_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user.user_name))])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Account")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/timeline"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _vm._v(" Market")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/orders"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" Orders")])]), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/wishlist"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v(" Wishlist")])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/buypoint"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Shop Together")])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" Logout")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Login")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/register"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Register")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a8dfcca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/account-menu.vue
// module id = 472
// module chunks = 0